import { API_ENDPOINTS } from '../../config/Config';

export const GET_MAM_SELF_REQUESTABLE_MARKETS = {
  // MamController.GetMarkets ("GetAllRequestableMarkets") already returns the same
  // Dictionary<string,string> shape this GraphQL field did - mutateData on the consuming
  // FieldDataBox handles the id/display projection regardless of transport.
  rest: { url: () => API_ENDPOINTS.GET_MAM_ALL_REQUESTABLE_MARKETS_DATA, params: () => ({}) },
  queryNode: 'selfRequestableMarkets',
  textField: 'display',
  keyField: 'id',
};

export const GET_MAM_SELF_REQUESTABLE_GROUPS_BY_COUNTRY = {
  // MamController.GetSelfRequestableGroupsByCountryAsync takes "countryCode", not "country" -
  // map the variable name at the boundary. The controller action returns List<MamGroupDto>
  // through the normal MVC pipeline, so it comes back camelCase (groupId/groupName/description).
  rest: {
    url: () => API_ENDPOINTS.GET_MAM_SELF_REQUESTABLE_GROUPS_BY_COUNTRY_DATA,
    params: (v: any) => ({ countryCode: v.country, search: v.search }),
  },
  queryNode: 'selfRequestableGroupsByCountry',
  textField: 'display',
  keyField: 'id',
};
